import { Marquee } from '../motion/Marquee';
import { Reveal } from '../motion/Reveal';
import { ENERGY_PROVIDERS } from '../../config/energy-providers';

const PARTNERS = ENERGY_PROVIDERS.map((p) => ({
  name: p.name,
  src: p.logo,
}));

export function PartnersMarquee() {
  return (
    <section
      aria-labelledby="partners-marquee-title"
      className="relative border-y border-stone-200/70 bg-stone-50/40 py-8 md:py-10"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-500/40 to-transparent"
      />

      <Reveal>
        <p
          id="partners-marquee-title"
          className="mb-5 px-4 text-center text-[11px] font-semibold uppercase tracking-[0.18em] text-balance text-stone-500"
        >
          On encaisse vos primes <span className="text-stone-400">·</span> on compare vos contrats <span className="text-stone-400">·</span> chez ces acteurs
        </p>

        <Marquee speed="slow">
          {PARTNERS.map((partner) => (
            <img
              key={partner.name}
              src={partner.src}
              alt={partner.name}
              loading="lazy"
              decoding="async"
              width={140}
              height={40}
              className="h-8 w-auto max-w-[130px] object-contain opacity-65 grayscale transition duration-300 ease-out hover:opacity-100 hover:grayscale-0 md:h-10 md:max-w-[150px]"
            />
          ))}
        </Marquee>
      </Reveal>
    </section>
  );
}
